import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';

/**
 * @deprecated Use the mezzanine component '@zocdoc-mezzanine/components-modal'
 */
const ButtonContainer = styled.div`
    padding-top: 19px;

    ${breakpoint.small} {
        padding-top: 38px;
    }
`;

export { ButtonContainer as default, ButtonContainer as ModalButtonContainer };
